import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import Dialog from '@/components/dialogs/Dialog';
import { hideWorkflowConfirmation, updateDatasetSettings } from '../actions';

const WorkflowChangeConfirmation = ({
  category,
  code,
  hide,
  name,
  theme,
  updateSettings,
  workflowKey,
  workflowName,
}) => {
  const intl = useIntl();
  return (
    <Dialog
      className="aridhia-workflow-change-confirmation"
      icon="sitemap"
      messageicon="warning circle"
      message={workflowKey ? 'settings.confirm.workflow.change' : 'settings.confirm.workflow.clear'}
      minimumDataEntryMet
      onClose={hide}
      onSave={() => updateSettings(category, code, { workflow_key: workflowKey }, name)}
      saveMessageId="actions.apply"
      size="tiny"
      theme={theme}
      title={intl.formatMessage({ id: 'settings.workflow.change.title' })}
      values={{ name: `'${workflowName}'` }}
      warning
    />
  );
};

const mapStateToProps = ({
  datasetSettings: {
    confirmWorkflow: {
      category, code, workflow, title,
    },
  },
}) => {
  const item = workflow || { code: null, workflow: { name: null } };
  return ({
    category,
    code,
    name: title,
    workflowKey: item.code,
    workflowName: item.workflow.name,
  });
};

const mapDispatchToProps = {
  hide: hideWorkflowConfirmation,
  updateSettings: updateDatasetSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowChangeConfirmation);
